import { createContext, useContext, useState, useEffect } from 'react'

const BackgroundContext = createContext()

export function BackgroundProvider({ children }) {
  const [selectedBackground, setSelectedBackground] = useState(() => {
    return localStorage.getItem('selectedBackground') || 'default'
  })

  useEffect(() => {
    localStorage.setItem('selectedBackground', selectedBackground)
    // Déclencher un événement pour notifier les autres composants
    window.dispatchEvent(new CustomEvent('backgroundChanged', { detail: selectedBackground }))
  }, [selectedBackground])

  return (
    <BackgroundContext.Provider value={{ selectedBackground, setSelectedBackground }}>
      {children}
    </BackgroundContext.Provider>
  )
}

export function useBackground() {
  const context = useContext(BackgroundContext)
  if (!context) {
    throw new Error('useBackground must be used within BackgroundProvider')
  }
  return context
}

